export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Notifications.json?hash=c1243e150ee8e74c175b1bccfb0e3fe2";